<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousFFView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center
            >{{
              portType == "Sea_Port"
                ? " Gate-In at Terminal By Road"
                : "Handover & Rail Out"
            }}
            ({{ handover.ccType }})</b-navbar-brand
          >
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button
                v-if="
                  railoutMain.ffRailOutId != '' ||
                  (handover.handoverToRailId != '' &&
                    handover.handoverTo == 'HandOverToPort')
                "
                variant="warning"
                size="sm"
                @click="proceedInv"
                >Proceed To Invoice</b-button
              >
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <!-- <b-card style="height:90px !important" class="HeaderMastBanner">
              <md-layout gutter>
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <b>Assignment No. : {{mainEntryData[0].ccImportSeries}}</b>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="25">
                  <b>Job Type : {{mainEntryData[0].jobType}}</b>
                </md-layout>
                <md-layout md-flex="40">
                  <md-layout md-flex="100">
                    <b>Shipping Line : {{mainEntryData[0].shippingLine}}</b>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout gutter>
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <b>Importer Name : {{mainEntryData[0].Importer}}</b>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="25">
                  <b>FF Activity : {{mainEntryData[0].containerInfo}}</b>
                </md-layout>
                <md-layout md-flex="40">
                  <md-layout md-flex="100"></md-layout>
                </md-layout>
              </md-layout>
              <md-layout gutter>
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <b>
                      Exporter Name : {{mainEntryData[0].Exporter}}
                      <br>
                    </b>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="25"></md-layout>
                <md-layout md-flex="40">
                  <md-layout md-flex="100"></md-layout>
                </md-layout>
              </md-layout>
            </b-card> -->

            <!-- <md-layout md-gutter class="gutr">
                <md-layout md-flex="90"></md-layout>
                <md-layout md-flex="10">
                  <md-button
                    v-if="!isPortLogin"
                    @click="addStatus"
                    style="position: fixed;z-index:999;top:83%;"
                    class="md-fab"
                  >
                    <md-icon>message</md-icon>
                  </md-button>
                </md-layout>
              </md-layout> -->
            <div
              class="phone-viewport"
              id="vehicleBooking"
              v-if="portType != 'Sea_Port'"
            >
              <md-list>
                <md-list-item
                  style="background: darkcyan !important"
                  id="showVisibility"
                  class="md-button-color-toggle"
                  v-bind:class="
                    handover.handoverToRailId == '' ||
                    handover.handoverTo == 'HandOverToPort'
                      ? 'md-active'
                      : ''
                  "
                  @click="showOverflow"
                >
                  <span style="color: white">Handover</span>

                  <md-list-expand>
                    <b-card>
                      <md-list>
                        <b-alert
                          v-if="
                            handover.editedBy != null && handover.editedBy != ''
                          "
                          id="1"
                          class="gutr"
                          show
                          dismissible
                          >Last Updated by
                          {{
                            handover.editedBy != null && handover.editedBy != ""
                              ? handover.editedBy
                              : handover.AddedBy
                          }}
                          on
                          {{
                            handover.updateTime == null &&
                            handover.updateTime == ""
                              ? handover.loginTime
                              : handover.updateTime
                          }}</b-alert
                        >
                        <md-layout md-gutter class="gutr">
                          <md-layout md-flex="25" md-flex-small="100">
                            <h5>
                              <b-badge>Handover Party *</b-badge>
                            </h5>
                            <span class="error" v-if="!handover.handoverTo">{{
                              errorList.handoverTo
                            }}</span>
                          </md-layout>
                        </md-layout>
                        <md-layout md-gutter class="gutr">
                          <md-layout md-flex="15" md-flex-small="100">
                            <md-radio
                              id="permitted"
                              name="permitted1"
                              md-value="HandOverToIcd"
                              v-model="handover.handoverTo"
                              class="md-primary margn-0px"
                              :disabled="isPortLogin"
                              >HandOver To ICD</md-radio
                            >
                          </md-layout>

                          <md-layout md-flex="15" md-flex-small="100">
                            <md-radio
                              id="permitted2"
                              name="permitted2"
                              v-model="handover.handoverTo"
                              md-value="HandOverToCFS"
                              class="md-primary margn-0px"
                              :disabled="isPortLogin"
                              >HandOver To CFS</md-radio
                            >
                          </md-layout>
                          <md-layout md-flex="20" md-flex-small="100">
                            <md-radio
                              id="permitted3"
                              name="permitted3"
                              v-model="handover.handoverTo"
                              md-value="HandOverToPort"
                              class="md-primary margn-0px"
                              :disabled="isPortLogin"
                              >HandOver To PORT</md-radio
                            >
                          </md-layout>
                        </md-layout>

                        <md-layout md-gutter class="gutr">
                          <md-layout md-flex="15" md-flex-small="100">
                            <label>LEO Date</label>
                            <md-layout md-flex="100" md-flex-small="100">
                              <date-picker
                              :format="selectDateFormat"
                                lang="en"
                                v-model="handover.leoDate"
                                id="date"
                                :disabled="isPortLogin"
                              ></date-picker>
                            </md-layout>
                          </md-layout>
                          <md-layout md-flex="5"></md-layout>
                          <md-layout md-flex="20" md-flex-small="100">
                            <label>Handover Date</label>
                            <md-layout md-flex="100" md-flex-small="100">
                              <date-picker
                              :format="selectDateFormat"
                                lang="en"
                                v-model="handover.handoverDate"
                                id="date"
                                :disabled="isPortLogin"
                              ></date-picker>
                              <span
                                class="error"
                                v-if="!handover.handoverDate"
                                >{{ errorList.handoverDate }}</span
                              >
                            </md-layout>
                          </md-layout>
                          <md-layout md-flex="5"></md-layout>
                          <md-layout md-flex="25" md-flex-small="100">
                            <md-layout md-flex="100">
                              <label>Custom Seal No.</label>
                              <b-form-input :formatter="capitalizeAll"
                                id="shippingBillNo"
                                name="shippingBillNo"
                                v-model="handover.ccSealNo"
                                :disabled="isPortLogin"
                              ></b-form-input>
                            </md-layout>
                          </md-layout>
                          <md-layout md-flex="5"></md-layout>
                          <md-layout
                            md-flex="25"
                            md-flex-small="100"
                            v-if="handover.handoverTo == 'HandOverToCFS'"
                          >
                            <label for="clientId">CFS Name</label>

                            <model-list-select
                              :list="cfsList"
                              id="cfs"
                              v-model="handover.cfsId"
                              option-value="pickupId"
                              option-text="pickupLocation"
                              placeholder="Select CFS"
                            ></model-list-select>
                          </md-layout>
                        </md-layout>
                        <div v-if="handover.handoverTo == 'HandOverToCFS'">
                          <md-layout
                            gutter
                            v-for="(item, index) in containerTypeMaster"
                            :key="index"
                            class="labelMargtop"
                          >
                            <md-layout md-flex="40" md-flex-small="100">
                              <label>Container Type</label>

                              <b-form-input :formatter="capitalizeAll"
                                :value="item.containerType"
                                disabled
                              />
                            </md-layout>

                            <md-layout md-flex="5"></md-layout>
                            <md-layout md-flex="55" md-flex-small="100">
                              <label>Container Incentive</label>

                              <b-input
                                id="containerIncentive"
                                name="containerIncentive"
                                v-model="containerIncentive[index]"
                              ></b-input>
                            </md-layout>
                          </md-layout>
                        </div>
                        <!-- v-if="handover.handoverTo=='HandOverToPort'" -->
                        <div class="mt-2">
                          <md-layout md-gutter class="gutr">
                            <md-layout md-flex="15" md-flex-small="100">
                              <h5>
                                <b-badge>TR Status</b-badge>
                              </h5>
                            </md-layout>
                          </md-layout>
                          <md-layout md-gutter class="gutr">
                            <md-layout md-flex="20" md-flex-small="100">
                              <md-radio
                                id="permitted"
                                name="permitted1"
                                md-value="1"
                                v-model="handover.trStatus"
                                class="md-primary margn-0px"
                                :disabled="isPortLogin"
                                >Handover to Surveyor</md-radio
                              >
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>
                            <md-layout md-flex="15" md-flex-small="100">
                              <md-radio
                                id="permitted2"
                                name="permitted2"
                                v-model="handover.trStatus"
                                md-value="2"
                                class="md-primary margn-0px"
                                :disabled="isPortLogin"
                                >Courier POL</md-radio
                              >
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>
                            <md-layout md-flex="20" md-flex-small="100">
                              <md-radio
                                id="permitted3"
                                name="permitted3"
                                v-model="handover.trStatus"
                                md-value="3"
                                class="md-primary margn-0px"
                                :disabled="isPortLogin"
                                >Handover to Line</md-radio
                              >
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>
                            <md-layout md-flex="20" md-flex-small="100">
                              <md-radio
                                id="permitted3"
                                name="permitted3"
                                v-model="handover.trStatus"
                                md-value="4"
                                class="md-primary margn-0px"
                                :disabled="isPortLogin"
                                >Courier to Pridel office</md-radio
                              >
                            </md-layout>
                          </md-layout>
                          <md-layout md-gutter class="gutr">
                            <md-layout md-flex="40" md-flex-small="100">
                              <label>TR</label>
                              <b-form-textarea :formatter="capitalizeAll"
                                id="TR"
                                name="TR"
                                v-model="handover.trDetail"
                                :disabled="isPortLogin"
                              ></b-form-textarea>
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>
                            <md-layout md-flex="55" md-flex-small="100">
                              <label>Courier Name</label>
                              <b-form-textarea :formatter="capitalizeAll"
                                id="TR"
                                name="TR"
                                v-model="handover.courierName"
                                :disabled="isPortLogin"
                              ></b-form-textarea>
                            </md-layout>
                          </md-layout>
                        </div>
                        <div class="gutr">
                          <b-card
                            style="background: whiteSmoke"
                            v-if="railOutPridel == 'Pridel'"
                          >
                            <div md-flex-small="100">
                              <md-layout md-gutter>
                                <h5>
                                  <b-badge>Payment Details</b-badge>
                                </h5>
                              </md-layout>
                            </div>
                            <md-layout md-gutter class="gutr">
                              <md-layout md-flex="35" md-flex-small="100">
                                <md-layout md-flex="100">
                                  <label>Shipping Bill No</label>
                                  <b-form-input :formatter="capitalizeAll"
                                    id="shippingBillNo"
                                    name="shippingBillNo"
                                    v-model="handover.shippingBillNo"
                                    :disabled="isPortLogin"
                                  ></b-form-input>
                                </md-layout>
                                <span
                                  class="error"
                                  v-if="
                                    !handover.shippingBillNo &&
                                    isPridel == 'Pridel'
                                  "
                                  >{{ errorList.shippingBillNo }}</span
                                >
                              </md-layout>
                              <md-layout md-flex="5"></md-layout>
                              <md-layout md-flex="30" md-flex-small="100">
                                <md-layout md-flex="100">
                                  <label>Receipt No</label>
                                  <b-form-input :formatter="capitalizeAll"
                                    id="receiptNo"
                                    name="receiptNo"
                                    v-model="handover.receiptNo"
                                    :disabled="isPortLogin"
                                  ></b-form-input>
                                </md-layout>
                                <span
                                  class="error"
                                  v-if="
                                    !handover.receiptNo && isPridel == 'Pridel'
                                  "
                                  >{{ errorList.receiptNo }}</span
                                >
                              </md-layout>
                              <md-layout md-flex="5"></md-layout>
                              <md-layout md-flex="25" md-flex-small="100">
                                <md-layout md-flex="100">
                                  <label>Amount Paid (In Rs)</label>
                                  <b-form-input :formatter="capitalizeAll"
                                    id="ammountPaid"
                                    name="ammountPaid"
                                    v-model="handover.ammountPaid"
                                    :disabled="isPortLogin"
                                  ></b-form-input>
                                </md-layout>
                              </md-layout>
                            </md-layout>

                            <md-layout md-gutter class="gutr">
                              <md-layout md-flex="15" md-flex-small="100">
                                <label>Payment Date</label>
                                <date-picker
                                :format="selectDateFormat"
                                  lang="en"
                                  v-model="handover.paymentDate"
                                  id="date"
                                  :disabled="isPortLogin"
                                ></date-picker>
                                <span
                                  class="error"
                                  v-if="
                                    !handover.paymentDate &&
                                    isPridel == 'Pridel'
                                  "
                                  >{{ errorList.paymentDate }}</span
                                >
                              </md-layout>
                              <md-layout md-flex="5"></md-layout>
                              <md-layout md-flex="15" md-flex-small="100">
                                <label>Payment Time</label>
                                <DatePicker
                                  v-model="handover.paymentTime"
                                  lang="en"
                                  type="time"
                                  format="HH:mm"
                                  placeholder="Select Time"
                                  :minute-step="1"
                                  :disabled="isPortLogin"
                                ></DatePicker>
                              </md-layout>
                              <md-layout md-flex="10"></md-layout>
                            </md-layout>
                          </b-card>
                        </div>

                        <md-layout md-gutter class="gutr">
                          <md-layout md-flex="40" md-flex-small="100">
                            <b-button
                              class="mt-3"
                              variant="primary"
                              id="addButtonLoader223"
                              @click="addHandoverToRail"
                              :disabled="isPortLogin"
                              style="z-index: 0"
                              >{{
                                handover.handoverTo == "HandOverToPort"
                                  ? "Save & Submit"
                                  : "Save & Proceed To Rail Out"
                              }}</b-button
                            >
                            <md-spinner
                              md-indeterminate
                              id="loader223"
                              style="display: none"
                            ></md-spinner>
                          </md-layout>
                        </md-layout>
                      </md-list>
                    </b-card>
                  </md-list-expand>
                </md-list-item>
              </md-list>
            </div>

            <div
              class="phone-viewport mt-4"
              id="railOut"
              v-if="
                (handover.handoverToRailId != '' &&
                  handover.handoverTo != 'HandOverToPort') ||
                portType == 'Sea_Port'
              "
            >
              <md-list>
                <md-list-item
                  class="md-button-color-toggle md-active"
                  style="overflow: visible; background: darkcyan !important"
                >
                  <span style="color: white">{{
                    portType == "Sea_Port"
                      ? " Gate-In at Terminal By Road"
                      : "Rail Out "
                  }}</span>

                  <md-list-expand>
                 
                      <md-list>
                        <div class="table-responsive mt-4">
                          <table
                            class="table table-sm table-bordered table-hover"
                          >
                            <tbody>
                              <tr>
                                <th scope="col">  <b-form-checkbox
      id="checkbox-1"
@input="sameForAll"
      v-model="sameForAllSelected"
      name="checkbox-1"
      value="1"
      unchecked-value="0"
    >
      
    </b-form-checkbox></th>
                                <th scope="col">Container</th>
                                <th v-if="portType != 'Sea_Port'" style="width: 200px" scope="col">
                                  {{
                                    portType == "Sea_Port"
                                      ? "TR Submission Mode"
                                      : "Train No."
                                  }}
                                </th>
                                <th
                                  v-if="portType == 'Sea_Port'"
                                  style="width: 250px"
                                  scope="col"
                                >
                                  TR Submission 
                                </th>
                                <th style="width: 200px" scope="col">
                                  {{
                                    portType == "Sea_Port"
                                      ? "Gate-In Type"
                                      : "Wagon  No."
                                  }}
                                </th>

                                <th style="width: 200px" scope="col">
                                  {{
                                    portType == "Sea_Port"
                                      ? "Gate-In Date"
                                      : "Train Departure Dt. & Time"
                                  }}
                                </th>
                                <th style="width: 150px" scope="col">
                                  {{
                                    portType == "Sea_Port"
                                      ? "Date of Container Arrival at Port"
                                      : "Train Arrival Dt. & Time At Port"
                                  }}
                                </th>
                                <th
                                  v-if="portType == 'Sea_Port'"
                                  style="width: 150px"
                                  scope="col"
                                >
                                  Vessel & Voyage Details
                                </th>
                               
                                <th
                                  v-if="portType == 'Sea_Port'"
                                  style="width: 150px"
                                  scope="col"
                                >
                                 Other Dates
                                </th>
                              
                              </tr>

                              <tr
                                v-for="(item, indx) in containerNoList"
                                :key="indx"
                              >
                                <th scope="row">{{ indx + 1 }} {{item.checked}}<br><br> <b-form-checkbox
      v-model="item.checked"

      value="1"
      unchecked-value="0"
    >
     
    </b-form-checkbox><br>  <b-button v-if="item.checked=='1'" @click="renderForAll(indx)"  size="sm" variant="light">Replicate</b-button></th>
                                <th scope="row">
                                  {{
                                    item.ContainerNo
                                      ? item.ContainerNo
                                      : item.containerNo
                                  }}<br /><small>{{
                                    item.containerType
                                  }}</small>
                                </th>
                               
                                <td v-if="portType != 'Sea_Port'">
                                  <b-form-input :formatter="capitalizeAll"
                                    size="sm"
                                    v-model="item.trainNo"
                                  ></b-form-input>
                                </td>
                                <td v-if="portType == 'Sea_Port'">
<small> TR Submission Mode</small>
 <model-list-select
                                    :list="trModeList"
                                    v-model="item.trSubmitMode"
                                    option-value="tV"
                                    option-text="tT"
                                    placeholder="Select Mode "
                                  ></model-list-select>
                                  <span v-if="item.trSubmitMode == 'Online'">
                                    <br />

                                    <b-form-textarea :formatter="capitalizeAll"
                                      v-if="item.trSubmitMode == 'Online'"
                                      placeholder="Enter Details"
                                      id="shippingBillNo"
                                      name="shippingBillNo"
                                      v-model="item.trModeOnline"
                                    ></b-form-textarea>

                                  </span>
<small> TR Submission Date</small>
                                  <date-picker
                                    style="width: 150px"
                                    v-model="item.trSubmitDate"
                                    lang="en"
                                    format="YYYY-MM-DD"
                                    :minute-step="1"
                                  ></date-picker>
                                </td>

                                <td v-if="portType == 'Sea_Port'">
                                  <model-list-select
                                    :list="gateInTypeList"
                                    v-model="item.gateInType"
                                    option-value="gV"
                                    option-text="gT"
                                    placeholder="Select Type"
                                  ></model-list-select>
                                </td>
                                <td v-else>
                                  <b-form-input :formatter="capitalizeAll"
                                    size="sm"
                                    v-model="item.wagonNo"
                                  ></b-form-input>
                                </td>
                                <td>
                                  <date-picker
                                    style="width: 200px"
                                    v-if="portType == 'Sea_Port'"
                                    lang="en"
                                    v-model="item.gateInTypeDate"
                                    type="datetime"
                                    format="YYYY-MM-DD hh:mm a "
                                    :minute-step="1"
                                  ></date-picker>
                                  <date-picker
                                    v-else
                                    v-model="item.trainDepartDate"
                                    lang="en"
                                    type="datetime"
                                    format="YYYY-MM-DD hh:mm a"
                                    :minute-step="1"
                                    :disabled="isPortLogin"
                                  ></date-picker>
                                </td>
                                <td>
                                  <date-picker
                                    style="width: 150px"
                                    v-if="portType == 'Sea_Port'"
                                    v-model="item.containerArivalAtPortDate"
                                    lang="en"
                                    type="datetime"
                                    format="YYYY-MM-DD"
                                    :minute-step="1"
                                  ></date-picker>
                                  <date-picker
                                    v-else
                                    lang="en"
                                    v-model="item.trainArriveDate"
                                    type="datetime"
                                    format="YYYY-MM-DD hh:mm a"
                                    :minute-step="1"
                                    :disabled="isPortLogin"
                                  ></date-picker>
                                </td>
                                <td v-if="portType == 'Sea_Port'">
<small>Vessel</small>
                                  <b-form-input :formatter="capitalizeAll"
                                    style="width: 200px"
                                    size="sm"
                                    v-model="item.vesselName"
                                  ></b-form-input>

<small>Voyage</small>
 <b-form-input :formatter="capitalizeAll"
                                    style="width: 200px"
                                    size="sm"
                                    v-model="item.vesselVoyage"
                                  ></b-form-input>
                                </td>
                              
                                <td v-if="portType == 'Sea_Port'">
<small>Vessel Gate-Open Date</small>
                                  <date-picker
                                    style="width: 150px"
                                    v-model="item.vesselEta"
                                    lang="en"
                                    type="datetime"
                                    format="YYYY-MM-DD"
                                    :minute-step="1"
                                  ></date-picker>
<small>Vessel ETD</small>
 <date-picker
                                    style="width: 150px"
                                    v-model="item.vesselEtd"
                                    lang="en"
                                    type="datetime"
                                    format="YYYY-MM-DD"
                                    :minute-step="1"
                                  ></date-picker>
<small>LEO Date</small>
 <date-picker
                                    style="width: 150px"
                                    v-model="item.gateOutDate"
                                    lang="en"
                                    type="datetime"
                                    format="YYYY-MM-DD"
                                    :minute-step="1"
                                  ></date-picker>
                                </td>
                               
                              
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <!-- v-if="getContainerNoData.length > 0 || railout.railOutTableId!=''" -->
                        <div
                          v-if="
                            getContainerNoData.length > 0 ||
                            railout.railOutTableId != ''
                          "
                        >
                          <!-- <md-layout md-gutter class="gutr">
                          

                              <md-layout md-flex="45" md-flex-small="100">
                                <label
                                  for="shippingId"
                                  v-if="railout.railOutTableId==''"
                                >Container No</label>
                                <model-list-select
                                  v-if="railout.railOutTableId=='' "
                                  :list="containerNoList"
                                  v-model="railout.containerNo"
                                  option-value="ContainerNo"
                                  option-text="ContainerNo"
                                  placeholder="Select Container No"
                                  :isDisabled="isPortLogin"
                                ></model-list-select>
                                <md-layout md-flex="100" v-else>
                                  <label>Container No</label>
                                  <b-form-input :formatter="capitalizeAll" v-model="railout.containerNo" disabled></b-form-input>
                                </md-layout>
                                <span
                                  class="error"
                                  v-if="!railout.containerNo"
                                >{{errorRail.containerNo}}</span>
                              </md-layout>
                            </md-layout> -->
                          <!-- <div v-if="portType!='Sea_Port'">
                              <md-layout md-gutter class="gutr">
                             
                                <md-layout md-flex="20" md-flex-small="100">
                                  <md-layout md-flex="100">
                                    <label>Train No</label>
                                    <b-form-input :formatter="capitalizeAll"
                                      id="trainNo"
                                      name="trainNo"
                                      v-model="railout.trainNo"
                                      :disabled="isPortLogin"
                                    ></b-form-input>
                                  </md-layout>
                                  <span class="error" v-if="!railout.trainNo">{{errorRail.trainNo}}</span>
                                </md-layout>

                                <md-layout md-flex="5"></md-layout>
                                <md-layout md-flex="20" md-flex-small="100">
                                  <md-layout md-flex="100">
                                    <label>Wagon No</label>
                                    <b-form-input :formatter="capitalizeAll"
                                      id="wagonNo"
                                      name="wagonNo"
                                      v-model="railout.wagonNo"
                                      :disabled="isPortLogin"
                                    ></b-form-input>
                                  </md-layout>
                                  <span class="error" v-if="!railout.wagonNo">{{errorRail.wagonNo}}</span>
                                </md-layout>
                              </md-layout>

                              <md-layout md-gutter class="gutr">
                           

                                <md-layout md-flex="20" md-flex-small="100">
                                  <label>Train Departure Date & Time</label>
                                  <date-picker
                                    v-model="railout.trainDepartDate"
                                    lang="en"
                                    type="datetime"
                                    format="YYYY-MM-DD hh:mm a"
                                    :minute-step="1"
                                    :disabled="isPortLogin"
                                  ></date-picker>
                                  <span
                                    class="error"
                                    v-if="!railout.trainDepartDate"
                                  >{{errorRail.trainDepartDate}}</span>
                                </md-layout>

                                <md-layout md-flex="5"></md-layout>
                                <md-layout md-flex="25" md-flex-small="100">
                                  <label>Train Arrival Date & Time At Port</label>
                                  <date-picker
                                    lang="en"
                                    v-model="railout.trainArriveDate"
                                    type="datetime"
                                    format="YYYY-MM-DD hh:mm a"
                                    :minute-step="1"
                                    :disabled="isPortLogin"
                                  ></date-picker>
                                  <span
                                    class="error"
                                    v-if="!railout.trainArriveDate"
                                  >{{errorRail.trainArriveDate}}</span>
                                </md-layout>
                              </md-layout>
                            </div> -->
                          <!-- <div v-if="portType == 'Sea_Port'">
                            <md-layout md-gutter class="labelMargtop">
                              <md-layout md-flex="25">
                                <label>Date of Container Arrival at Port</label>
                                <date-picker
                                  v-model="railout.containerArivalAtPortDate"
                                  lang="en"
                                  type="datetime"
                                  format="YYYY-MM-DD"
                                  :minute-step="1"
                                ></date-picker>
                              </md-layout>
                              <md-layout md-flex="5"></md-layout>

                              <md-layout md-flex="25">
                                <label>TR Submission Date</label>
                                <date-picker
                                  v-model="railout.trSubmitDate"
                                  lang="en"
                                  type="datetime"
                                  format="YYYY-MM-DD"
                                  :minute-step="1"
                                ></date-picker>
                              </md-layout>
                              <md-layout md-flex="5"></md-layout>

                              <md-layout md-flex="30">
                                <md-layout md-flex="100">
                                  <label>TR Submission Mode</label>
                                  <model-list-select
                                    :list="trModeList"
                                    v-model="railout.trSubmitMode"
                                    option-value="tV"
                                    option-text="tT"
                                    placeholder="Select Mode "
                                  ></model-list-select>
                                </md-layout>
                              </md-layout>
                            </md-layout>
                            <md-layout
                              md-gutter
                              class="gutr"
                              v-if="railout.trSubmitMode == 'Online'"
                            >
                              <md-layout md-flex="30">
                                <md-layout md-flex="100">
                                  <label>Enter Details</label>
                                  <b-form-textarea :formatter="capitalizeAll"
                                    id="shippingBillNo"
                                    name="shippingBillNo"
                                    v-model="railout.trModeOnline"
                                  ></b-form-textarea>
                                </md-layout>
                              </md-layout>
                            </md-layout>
                            <md-layout md-gutter class="labelMargtop">
                              <md-layout md-flex="30">
                                <label for="ccType">Gate-In Type</label>
                                <model-list-select
                                  :list="gateInTypeList"
                                  v-model="railout.gateInType"
                                  option-value="gV"
                                  option-text="gT"
                                  placeholder="Select GateIn Type"
                                ></model-list-select>
                              </md-layout>
                            </md-layout>
                            <md-layout md-gutter class="labelMargtop">
                           

                              <md-layout md-flex="15">
                                <label>Gate-In Date</label>
                                <date-picker
                                  lang="en"
                                  v-model="railout.gateInTypeDate"
                                  type="datetime"
                                  format="YYYY-MM-DD hh:mm a "
                                  :minute-step="1"
                                ></date-picker>
                              </md-layout>

                           
                            </md-layout>
                            <md-layout md-gutter class="labelMargtop">
                              <md-layout md-flex="30">
                                <md-layout md-flex="100">
                                  <label>Vessel Name</label>
                                  <b-form-input :formatter="capitalizeAll"
                                    id="trainNo"
                                    name="trainNo"
                                    v-model="railout.vesselName"
                                  ></b-form-input>
                                </md-layout>
                              </md-layout>

                              <md-layout md-flex="5"></md-layout>
                              <md-layout md-flex="45">
                                <md-layout md-flex="100">
                                  <label>Vessel Voyage</label>
                                  <b-form-input :formatter="capitalizeAll"
                                    id="vesselVoyage"
                                    name="vesselVoyage"
                                    v-model="railout.vesselVoyage"
                                  ></b-form-input>
                                </md-layout>
                              </md-layout>
                            </md-layout>
                            <md-layout md-gutter class="labelMargtop">
                              <md-layout md-flex="25">
                                <label>Vessel Gate-Open Date</label>
                                <date-picker
                                  lang="en"
                                  v-model="railout.vesselEta"
                                  type="datetime"
                                  format="YYYY-MM-DD "
                                  :minute-step="1"
                                ></date-picker>
                              </md-layout>
                              <md-layout md-flex="5"></md-layout>
                              <md-layout md-flex="20">
                                <label>Vessel ETD</label>
                                <date-picker
                                  lang="en"
                                  v-model="railout.vesselEtd"
                                  type="datetime"
                                  format="YYYY-MM-DD "
                                  :minute-step="1"
                                ></date-picker>
                              </md-layout>
                            </md-layout>
                            <md-layout md-gutter class="labelMargtop">
                              <md-layout md-flex="15">
                                <label>LEO Date</label>
                                <date-picker
                                  lang="en"
                                  v-model="railout.gateOutDate"
                                  type="datetime"
                                  format="YYYY-MM-DD hh:mm a "
                                  :minute-step="1"
                                ></date-picker>
                              </md-layout>
                            </md-layout>
                          </div> -->

                          <!-- <b-card class="mt-3" style="background:whiteSmoke">
                                   <h5>
                              <b-badge>Additional Expense Detail</b-badge>
                            </h5>
                                <md-layout md-gutter >
                                 
                                  <md-layout md-flex="30" md-flex-small="100">
                                    <label for="shippingId">Additional Expense</label>
                                    <model-list-select
                                      :list="additionalExpense"
                                      v-model="railout.additionalExpenses"
                                      option-value="value"
                                      option-text="show"
                                      placeholder="Select Additional Expense"
                                      :isDisabled="isPortLogin"
                                    ></model-list-select>
                                    <span
                                      class="error"
                                      v-if="!railout.additionalExpenses"
                                    >{{errorAdditional}}</span>
                                  </md-layout>
                                  <md-layout md-flex="5"></md-layout>
                                  <md-layout md-flex="10" md-flex-small="100">
                                    <label for="shippingId">Amount</label>
                                    <b-input
                                      type="number"
                                      :min="0"
                                      v-model="railout.amount"
                                      :disabled="isPortLogin"
                                    ></b-input>
                                    <span class="error" v-if="!railout.amount">{{errorAmount}}</span>
                                  </md-layout>
                                  <md-layout md-flex="5"></md-layout>
                                  <md-layout md-flex="30" md-flex-small="100">
                                    <label for="shippingId">Remarks</label>
                                    <b-textarea v-model="railout.remark" :disabled="isPortLogin"></b-textarea>
                                  </md-layout>
                                  <md-layout md-flex="5"></md-layout>
                                  <md-layout
                                    md-flex="10"
                                    md-flex-small="100"
                                    style="margin-top:55px"
                                  >
                                    <b-button
                                      variant="info"
                                      size="sm"
                                      id="addButtonLoader116"
                                      @click="addExpense"
                                      :disabled="isPortLogin"
                                    >Add Expenses</b-button>
                                  </md-layout>
                                </md-layout>
                                <div class="mt-2" v-if="railout.allAdditionalExpense.length>0">
                                
                                
                                  <div class="box-body">
                                    <table
                                      id="railOuttariff1"
                                      class="table table-bordered "
                                    >
                                      <thead>
                                        <tr>
                                          <th>Sr No.</th>
                                          <th>Additional Expense</th>
                                          <th v-if="!isPortLogin">Amount</th>
                                          <th>Remark</th>

                                          <th v-if="!isPortLogin">Delete</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr></tr>
                                        <tr
                                          v-for="(item,index) in railout.allAdditionalExpense"
                                          :key="index"
                                        >
                                          <td>{{index+1}}</td>
                                          <td>{{item.additionalExpenses}}</td>
                                          <td v-if="!isPortLogin">{{item.amount}}</td>
                                          <td>{{item.remark}}</td>

                                          <td v-if="!isPortLogin">
                                            <md-button
                                              class="md-icon-button md-raised md-dense"
                                              @click="removeNotify(index)"
                                            >
                                              <md-icon>delete_sweep</md-icon>
                                            </md-button>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>

                              
                                </div>
                              </b-card> -->

                          <md-layout md-gutter class="gutr">
                            <md-layout md-flex="15">
                              <b-button
                                class="mt-3"
                                variant="primary"
                                id="addButtonLoader116"
                                @click="addRailOutTables('')"
                                :disabled="isPortLogin"
                                >Save & Submit</b-button
                              >
                              <md-spinner
                                md-indeterminate
                                id="loader116"
                                style="display: none"
                              ></md-spinner>
                            </md-layout>
                          </md-layout>
                        </div>
                        <div
                          class="mt-3"
                          v-if="railOutTableArrayList.length > 0"
                        >
                          <!-- <div >
                                <h5>
                              <b-badge>Rail Out Details</b-badge>
                            </h5>
                           
                            </div>

                       
                            <div class="box-body">
                              <table id="railOuttariff" class="table table-bordered">
                                <thead>
                                  <tr>
                                    <th>Sr No.</th>
                                    <th>Container No</th>
                                  
                                    <th>Last Updated By</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr></tr>
                                  <tr v-for="(item,index) in railOutTableArrayList" :key="index">
                                    <td>{{index+1}}</td>
                                    <td
                                      @click="editRailTable(item)"
                                      class="showMoreData"
                                    >{{item.containerNo}}</td>
                                   
                                    <td>{{item.lastUpdate!=null && item.lastUpdate!='' ?item.lastUpdate:item.lastAdd}} on {{item.updateTime==null && item.updateTime==''?item.loginTime:item.updateTime}}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div> -->

                          <!-- /.box-body -->
                        </div>
                      </md-list>
                   
                  </md-list-expand>
                </md-list-item>
              </md-list>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22"
      @close="onClose22"
    ></md-dialog-alert>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopData"
    ></md-dialog-alert>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop11212"
      @close="onClose11212"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Custom Clearance") &&
      this.$sessionsStorage.get("editCcImportId") != undefined &&
      this.$sessionsStorage.get("editCcImportId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/CCImport/CCImportEntry");
      this.getServicesData();
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }

    // this.vehicle();
  },

  watch: {
    railout: {
      handler: function (newVal, oldVal) {
        if (this.railout.containerNo != "") {
          let arry = this.getContainerNoData.filter((x) => {
            return x.ContainerNo == this.railout.containerNo;
          });

          if (arry.length > 0) {
            this.railout.containerType = arry[0].ContainerType;
          }
        }

        if (this.railout.additionalExpenses != "") {
          let arry1 = this.railout.allAdditionalExpense.filter((x) => {
            // return x.locationType == "Sea_Port" || x.locationType == "Icd";
            return x.additionalExpenses == this.railout.additionalExpenses;
          });

          if (arry1.length > 0) {
            let array2 = this.additionalExpense.filter((x) => {
              return x.value == arry1[0]["additionalExpenses"];
            });
            this.alert.content = array2[0]["show"] + " Already Exists.";
            this.railout.additionalExpenses = "";
            this.$refs["addPopData"].open();
          }
        }
      },
      deep: true,
    },
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    },
  },
  data() {
    return {
      selectDateFormat,
      gateInTypeList: [
        {
          gV: "1",
          gT: "Buffer",
        },
        {
          gV: "2",
          gT: "Ground Rent",
        },
        {
          gV: "3",
          gT: "Normal",
        },
        {
          gV: "4",
          gT: "Via ",
        },
      ],
      trModeList: [
        {
          tV: "Online",
          tT: "Online",
        },
        {
          tV: "Handover_to_Line_Surveyor",
          tT: "Handover to Line / Surveyor",
        },
        {
          tV: "Handover_to_SL_City_office",
          tT: "Handover to S/L City office",
        },
      ],
      isLoading: "",
      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      containerIncentive: [],
      handover: {
        updateTime: "",
        loginTime: "",
        AddedBy: "",
        editedBy: "",
        courierName: "",
        trDetail: "",
        statusFinal: "",
        containerIncentive: "",
        handoverToRailId: "",
        handoverTo: "",
        cfsId: "",
        handoverDate: "",
        shippingBillNo: "",
        receiptNo: "",
        ammountPaid: "",
        paymentDate: "",
        paymentTime: "",
        ccSealNo: "",
        leoDate: "",
        trStatus: "",
        ccType: this.$sessionsStorage.get("editCcType"),
      },
      errorList: {
        handoverTo: "",
        handoverDate: "",
        shippingBillNo: "",
        paymentDate: "",
        receiptNo: "",
      },
      showVisible: false,
      showVisibleRail: false,
      railout: {
        trModeOnline: "",
        ffRailOutId: "",
        containerNo: "",
        containerType: "",
        additionalExpenses: "",
        amount: "",
        remark: "",

        railOutTableId: "",
        trainDepartDate: "",
        trainNo: "",
        wagonNo: "",
        trainDepartTime: "",
        trainArriveDate: "",
        allAdditionalExpense: [],
        containerArivalAtPortDate: "",
        gateInType: "",
        gateInTypeDate: "",
        vesselName: "",
        vesselVoyage: "",
        vesselEta: "",
        vesselEtd: "",
        trSubmitMode: "",
        trSubmitDate: "",
        portInDate: "",
        gateOutDate: "",
        cfsName: "",
      },

      removerailoutVmodel: {
        railOutTableId: "",
        ffExecutionContainerId: "",
        containerNo: "",
      },
      errorRail: {
        ffExecutionContainerId: "",
        trainNo: "",
        wagonNo: "",
        trainArriveDate: "",
        trainDepartDate: "",
      },

      arrayRailError: [
        "Select Container No",
        "Enter train No",
        "Enter wagon No",
        "Select Arrival Date",
        "Select Departure Date",
      ],
      stuffingType: "",
      railoutMain: {
        ffRailOutId: "",
        railOutTableId: "",
        handoverToRailId: "",
        ccImportId: this.$sessionsStorage.get("editCcImportId"),
        ccType: this.$sessionsStorage.get("editCcType"),
      },

      additionalExpense: [
        {
          value: "Marking",
          show: "Marking/Labelling",
        },
        {
          value: "Palletization",
          show: "Palletization",
        },
        {
          value: "Fumigation",
          show: "Fumigation",
        },

        {
          value: "Lashing",
          show: "Lashing/Choking",
        },
        {
          value: "Legalization",
          show: "Legalization",
        },
        {
          value: "COC_GSP",
          show: "COC/GSP",
        },
        {
          value: "Phyto",
          show: "Phyto",
        },

        {
          value: "APEDA",
          show: "APEDA",
        },
        {
          value: "HealthCertificate",
          show: "Health Certificate",
        },

        {
          value: " WildlifeNOC",
          show: " Wildlife NOC",
        },
        {
          value: "OthersSpecify",
          show: " Others Specify",
        },
      ],
      railOutTableArray: [],
      containerTypeMaster: [],
      mainEntryData: [],
      cfsList: [],
      deleteId: "",
      railOutPridel: "",
      portType: "",

      transhipmentArray: [],
      getPortData: ["Agra"],

      error: {
        clientNameError: "",
        toPortError: "",
        fromPortError: "",
        transhipmentNameError: "",
        addOneTranError: "",
      },
      getContainerNoData: [],
      isPridel: "",
      getCLientData: ["gfdg"],
      showSegmentArray: [],
      driverNameDetail: ["iji"],
      editVar: {
        Inputval:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "New",
      },
      departmentName: "",
      designation: "",
      portAccess: "",
      commodityListName: [],
      getShippingLineData: ["zim"],
      getlocationListData: ["agra"],
      validate: true,
      validateRail: true,
      clientNameError: "",
      addDriverError1: "",
      addTruckError4: "",
      errorAmount: "",
      errorAdditional: "",
sameForAllSelected:"",
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
  },
  computed: {
    railOutTableArrayList() {
      return this.railOutTableArray;
    },

    isPortLogin() {
      return (this.departmentName == "Port/ICD" &&
        this.designation == "superviser") ||
        this.portAccess == 1
        ? false
        : true;
    },
    containerNoList() {
      return this.getContainerNoData;
    },
    shippingList() {
      return this.getShippingLineData;
    },
    locationList() {
      return this.getlocationListData;
    },
    PortList() {
      return this.getPortData;
    },
    viewDocument() {
      return this.handover.uploadDriverDoc.split(",");
    },
    vehicleMasterList() {
      return this.driverNameDetail;
    },
    commodityList() {
      return this.commodityListName;
    },
  },
  methods: {
// setChecked(indx){
// this.getContainerNoData[indx].checked='1'
// console.log(this.getContainerNoData[indx].checked)


// },
renderForAll(index){

let selectedIndex=this.containerNoList[index];

// let arrySel=this.containerNoList.filter(x=>{

// return x.checked=='1';
// });

// if(arrySel.length>0){
this.containerNoList.map(x=>{
if(x.checked=='1' && this.portType=='Sea_Port'){ 
x.trSubmitMode=selectedIndex.trSubmitMode;
x.trSubmitDate=selectedIndex.trSubmitDate;
x.gateInType=selectedIndex.gateInType;
x.gateInTypeDate=selectedIndex.gateInTypeDate;
x.containerArivalAtPortDate=selectedIndex.containerArivalAtPortDate;
x.vesselName=selectedIndex.vesselName;
x.vesselVoyage=selectedIndex.vesselVoyage;
x.vesselEta=selectedIndex.vesselEta;
x.vesselEtd=selectedIndex.vesselEtd;
x.gateOutDate=selectedIndex.gateOutDate;
x.trModeOnline=selectedIndex.trModeOnline;
}else{
x.trainNo=selectedIndex.trainNo;
x.wagonNo=selectedIndex.wagonNo;
x.trainArriveDate=selectedIndex.trainArriveDate;
x.trainDepartDate=selectedIndex.trainDepartDate;
x.trainDepartTime=selectedIndex.trainDepartTime;



}


});



//}

//console.log(selectedIndex)


},
sameForAll(){
if(this.sameForAllSelected=='1'){ 
for(let i=0;i<this.containerNoList.length;i++){
this.containerNoList[i].checked="1"
}
}else{
for(let i=0;i<this.containerNoList.length;i++){
this.containerNoList[i].checked="0"
}
}




},
    proceedInv() {
      this.$router.push({
        path: "/CCImport/CCInvoiceForTallyExport",
      });
    },
    addStatus() {
      let data = {
        jobType: "2",
        typeOf: "1",
        allMessageId: this.$sessionsStorage.get("editCcImportId"),
        statusMain: this.handover.statusFinal,
        login: "portLogin",
      };

      this.$sessionsStorage.set("MessageStatus", JSON.stringify(data));

      this.$router.push({
        path: "/UpdateStatus/internalAssignStatus",
      });
    },
    removeNotify(index) {
      this.railout.allAdditionalExpense.splice(index, 1);
    },

    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "ff_railouttable",
          tableId: "railOutTableId",
          isActive: "isRailTableActive",
          tableVal: this.deleteId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            this.getData();
            this.deleteId = "";
          })
          .catch((error) => {});
      }
    },

    getPortId1(item) {
      this.handover.toportId = item.portId;
    },
    getPortId2(item) {
      this.handover.fromportId = item.portId;
    },
    getPortId3(item) {
      this.transhipment.tentportId = item.portId;
    },

    JqueryFun() {
      //   return $(function() {
      //     return $("#railOuttariff").DataTable();
      //   });
    },
    clientFilter(list, query) {
      return this.getCLientData.filter((x) => {
        return x.clientName.toLowerCase().includes(query.toLowerCase());
      });
    },
    PortFilter(list, query) {
      return this.getPortData.filter((x) => {
        return x.portName.toLowerCase().includes(query.toLowerCase());
      });
    },
    validateFFExport() {
      let validate_new = true;

      if (this.handover.handoverTo == "") {
        $("#handoverTo").focus();
        this.errorList.handoverTo = "Please Select Handover";
        validate_new = false;
      }

      if (this.handover.handoverDate == "") {
        $("#handoverDate").focus();
        this.errorList.handoverDate = "Please Select Handover Date";
        validate_new = false;
      }

      if (this.handover.shippingBillNo == "" && this.isPridel == "Pridel") {
        $("#shippingBillNo").focus();
        this.errorList.shippingBillNo = "Please Enter Shipping Bill No";
        validate_new = false;
      }

      if (this.handover.receiptNo == "" && this.isPridel == "Pridel") {
        $("#receiptNo").focus();
        this.errorList.receiptNo = "Please Enter Receipt  No";
        validate_new = false;
      }

      if (this.handover.paymentDate == "" && this.isPridel == "Pridel") {
        this.errorList.paymentDate = "Please Select Payment Date";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    editRailTable(item) {
      this.railout.allAdditionalExpense = [];
      Object.keys(this.railout).map((x) => {
        if (x == "allAdditionalExpense") {
          let array = item[x].split("$$$");
          array.map((y) => {
            let objVal = y.split("$-$");
            let obj = {
              additionalExpenses: objVal[0],
              amount: objVal[1],
              remark: objVal[2],
            };

            this.railout.allAdditionalExpense.push(obj);
          });
        } else {
          this.railout[x] = item[x] || "";
        }
      });

      // this.railout.additionalExpenses=

      this.railoutMain.ffRailOutId = item.ffRailOutId;
    },
    validateExpense() {},
    addExpense() {
      let validate_new = true;
      if (this.railout.additionalExpenses == "") {
        this.errorAdditional = "Select Expenses";
        validate_new = false;
      } else {
        this.errorAdditional = "";
      }

      if (this.railout.amount == "") {
        this.errorAmount = "Select Amount";
        validate_new = false;
      } else {
        this.errorAmount = "";
      }

      if (validate_new == false) {
        return false;
      }

      this.addRailOutTables("sfds");
    },
    addHandoverToRail() {
      this.handover["containerIncentive"] = "";
      this.containerIncentive.map((x) => {
        this.handover["containerIncentive"] += x + ",";
      });

      this.handover["ccImportId"] = this.$sessionsStorage.get("editCcImportId");

      this.validateFFExport();
      if (this.validate != false) {
        $("#addButtonLoader223").css("display", "none");
        $("#loader223").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Custom/addHandoverToRail.php`,
          data: JSON.stringify(this.handover),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              $("#loader223").css("display", "none");
              $("#addButtonLoader223").css("display", "block");
              if (this.handover.handoverToRailId == "") {
                this.alert.content = "Data Added Succesfully";
              } else {
                this.alert.content = "Data Updated Succesfully";
              }
              this.$refs["addPopData"].open();
              this.getData();
            }
          })
          .catch((error) => {});
      }
    },
    onClose11212() {
      if (this.stuffingType == "factoryStuffing") {
        this.$router.push({
          path: "/freightForward/ffExecution",
        });
      } else {
        this.$router.push({
          path: "/freightForward/ffexecutionWareHouse",
        });
      }
    },
    showSailFPOD() {
      this.$router.push({
        path: "/freightForward/sailFPOD",
      });
    },
    validateTranshipment() {
      let validate_new = true;

      if (this.transhipment.tentPortName == "") {
        $("#tentPortName").focus();
        this.error.tentPortNameError = "Enter Tentative Port Name";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    validateRail1(id) {
      let validate_new = true;
      if (this.portType != "Sea_Port") {
        Object.keys(this.errorRail).map((x, index) => {
          if (this.railout[x] == "") {
            this.errorRail[x] = this.arrayRailError[index];
            validate_new = false;
          }
        });
      }
      if (id != "") {
        if (this.railout.allAdditionalExpense.length == 0) {
          if (this.railout.additionalExpenses == "") {
            this.errorAdditional = "Select Expenses";
            validate_new = false;
          } else {
            this.errorAdditional = "";
          }

          if (this.railout.amount == "") {
            this.errorAmount = "Select Amount";
            validate_new = false;
          } else {
            this.errorAmount = "";
          }
        }
      }

      if (validate_new == false) {
        this.validateRail = false;
      } else {
        this.validateRail = true;
      }
    },

    addRailOutTables(id) {
      this.isLoading = true;
      console.log(this.containerNoList);
    //return false;
      //  this.validateRail1(id);

      if (this.validateRail != false) {
        if (
          this.railout.additionalExpenses != "" &&
          this.railout.amount != ""
        ) {
          let obj = {
            additionalExpenses: this.railout.additionalExpenses,
            amount: this.railout.amount,
            remark: this.railout.remark == "" ? "N/A" : this.railout.remark,
          };
          this.railout.allAdditionalExpense.push(obj);
        }

        let new_data = {
          railoutMain: this.railoutMain,
          railout: this.railout,
          containerList: this.containerNoList,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Custom/addRailOutTable.php`,
          data: JSON.stringify(new_data),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              this.railoutMain.ffRailOutId = data.ffRailOutId;
              this.railout.railOutTableId = data.railOutTableId;

              if (this.railout.railOutTableId == "") {
                this.alert.content = "Added Succesfully";
              } else {
                this.alert.content = "Data Updated Succesfully";
                this.$refs["addPop22"].open();
              }

              if (id == "") {
                Object.keys(this.railout).map((x) => {
                  if (x == "allAdditionalExpense") {
                    this.railout[x] = [];
                  } else {
                    this.railout[x] = "";
                  }
                });
                Object.keys(this.errorRail).map((x) => {
                  this.errorRail[x] = "";
                });

                this.getData();
              } else {
                this.railout.amount = "";
                this.railout.remark = "";
                this.railout.additionalExpenses = "";
              }
              this.isLoading = false;
            }
          })
          .catch((error) => {});
      }
    },
    onClose22() {},
    getData() {
      this.isLoading = true;
      this.railOutTableArray = [];
      let vehicle_drive = {
        containerNo: "containerNo",
        ccImportId: this.$sessionsStorage.get("editCcImportId"),
        ccType: this.$sessionsStorage.get("editCcType"),
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Custom/fetchtoHandoverToRailrailOutCC_NewV3.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            console.log(data, "ppp");
            if (data.UserDetail.length > 0) {
              this.designation = data.UserDetail[0].designation;
              this.portAccess = data.UserDetail[0].portLoginAccess;
              let filter1 = data.UserDetail[0].departmentName1
                .split(",")
                .filter((x) => {
                  return x == "Port/ICD";
                });

              this.departmentName = filter1.length > 0 ? "Port/ICD" : "fdsf";
            }

            if (data.containerDetail.length > 0) {
              this.getContainerNoData = data.containerDetail;
            } else {
              this.getContainerNoData = data.railOutTableData;

            }

            if (data.handOverDetail.length > 0) {
              Object.keys(this.handover).map((x) => {
                if (x == "containerIncentive") {
                  if (data.handOverDetail[0][x] != null) {
                    this.containerIncentive = data.handOverDetail[0][x].split(
                      ","
                    );
                  }
                }
                this.handover[x] = data.handOverDetail[0][x] || "";
              });
              this.railoutMain.handoverToRailId = this.handover.handoverToRailId;
            }
            if (data.containerTypeMaster.length > 0) {
              this.containerTypeMaster = data.containerTypeMaster;
            }

            if (data.railOutTableData.length > 0) {
              this.railOutTableArray = data.railOutTableData;
            }
            if (data.railOutDetail.length > 0) {
              Object.keys(this.railoutMain).map((x) => {
                this.railoutMain[x] = data.railOutDetail[0][x] || "";
              });
            }
            if (data.ccEntryDetails.length > 0) {
              this.railOutPridel = data.ccEntryDetails[0]["pdaDetail"];
              this.portType = data.ccEntryDetails[0].portType;
              this.mainEntryData = data.ccEntryDetails;
              this.handover.statusFinal = data.ccEntryDetails[0]["statusFinal"];
            }
            if (data.cfsData.length > 0) {
              this.cfsList = data.cfsData;
            }
            this.isLoading = false;
            this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    addNew() {
      this.$router.push({
        path: "/client/addClient",
      });
    },
    deleteData(item) {
      this.deleteId = item.railOutTableId;

      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },

    previousFFView() {
      window.history.go(-1);
      // if (
      //   this.isPortLogin &&
      //   this.$sessionsStorage.get("editCcType") == "Import"
      // ) {
      //   this.$router.push({
      //     path: "/CCImport/ExecutionImport"
      //   });
      // }
      // if (
      //   this.isPortLogin &&
      //   this.$sessionsStorage.get("editCcType") == "Export"
      // ) {
      //   this.$router.push({
      //     path: "/CCImport/ediExecution"
      //   });
      // } else if (this.$sessionsStorage.get("editCcType") == "Import") {
      //   this.$router.push({
      //     path: "/CCImport/CCImportDetails"
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/CCImport/CCExportDetail"
      //   });
      // }
    },

    showOverflow() {
      if (this.showVisible == false) {
        this.showVisible = true;
        $("#showVisibility").css("overflow", "visible");
      } else {
        this.showVisible = false;
        $("#showVisibility").css("overflow", "hidden");
      }
    },

    getServicesData() {
      this.showSegmentArray = [
        {
          value: "Freight_Forwarding",
          show: "Freight Forwarding(FF)",
          flex: "20",
        },
        {
          value: "Customs_Clearance",
          show: "Customs Clearance(CC)",
          flex: "20",
        },
        {
          value: "Transportation",
          show: "Transportation(TPT)",
          flex: "20",
        },

        {
          value: "All",
          show: "All",
          flex: "15",
        },
      ];
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// ccHandoverToRail.vue?072f0e4a